import { ApiBase } from '@/api/api'
import { makeGetRequest } from '@/api/fetchCalls'
import type { StripeIntegration } from '@/types/stripe-integration'

export async function getStripeIntegration(): Promise<StripeIntegration | null> {
  try {
    return (await makeGetRequest(
      ApiBase + `/stripe/integrations`
    )) as Promise<StripeIntegration>
  } catch (error) {
    return null
  }
}
